import { getStateAtNamespaceKey } from 'redux/get-state-at-namespace-key';
import { createSelector } from 'reselect';

export const getGiftCards = (state: WtrState) => getStateAtNamespaceKey(state, 'order')?.giftCards;

export const getCurrentGiftCards = createSelector([getGiftCards], (giftCards = []) =>
  giftCards.map(({ serialNumber }) => ({ serialNumber })),
);
